import React from 'react';

const SectionLayout = ({ children }) => {
  return <section className="container">{children}</section>;
};

export default SectionLayout;
